import { useEffect } from 'react';

import useDispatch from '@app/hooks/useDispatch';
import useSelector from '@app/hooks/useSelector';
import { getBranch, getProject, getUserRights } from '@app/selectors';

import { badgeActions } from '../../store/badges/reducers';
import ProjectHeader from './ProjectHeader';

const { getBadgeStatus } = badgeActions;

const ProjectHeaderContainer = ({ activeItem, sticky = false }: { activeItem: string; sticky: boolean }) => {
    const projectState = useSelector(getProject);
    const branchState = useSelector(getBranch);
    const userRightsState = useSelector(getUserRights);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            getBadgeStatus({
                projectId: projectState.id,
                branchId: branchState.branchId,
            }),
        );
    }, [projectState.id, branchState.branchId, dispatch]);

    return (
        <ProjectHeader
            project={projectState}
            branch={branchState}
            userRights={userRightsState}
            activeItem={activeItem}
            sticky={sticky}
        />
    );
};

export default ProjectHeaderContainer;
